<template>
  <!-- FILTROS -->
  <div class="row" style="width: 100%">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <form v-on:submit.prevent="buscarLeiloes()">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <div class="input-group mb-3">
                    <input
                      class="form-control"
                      id="id"
                      v-model="filtro"
                      placeholder="Localizar em todos os lotes e leilões ATIVOS (Título, Descrição, Cidade, Estado, Processo, Número do Leilão, Número do Lote)"
                    />

                    <span class="input-group-append">
                      <button @click="buscarLeiloes()" style="border-radius: 2px" type="submit" class="btn btn-info">Filtrar</button>
                      <button @click="limparFiltros()" style="border-radius: 2px" type="submit" class="btn btn-default">Limpar filtros</button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div style="padding: 0px 0px 10px 0px; color: red" v-if="searchBuscado">
    Exibindo resultados para "{{ filtro }}"
    <i class="fa-regular fa fa-close" style="margin-left: 5px; color: red; cursor: pointer" @click="limparFiltros"></i>
  </div>

  <div class="row" style="width: 100%" id="leiloes">
    <div class="col-sm-12" v-if="leiloes">
      <div class="card-tools clearfix">
        <!--
        <ul class="pagination pagination-sm m-0 float-right" style="margin-right: 15px">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&laquo;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&raquo;</a></li>
        </ul>
        -->
        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item">
            <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
          </li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
        </ul>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-4 md-div" v-for="leilao in leiloes" :key="leilao" :value="leilao" v-if="leiloes">
      <card-mosaico :leilao="leilao" />
    </div>

    <div class="col-sm-12" v-if="leiloes">
      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo leilões do {{ inicio + 1 }} ao {{ inicio + leiloes.length }}
          <p>Total de leilões {{ total }}</p>
        </div>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px">
            <!--
            <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

            <select @change="alterarQtdPagina()" class="card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
              <option :value="3">3</option>
              <option :value="12">12</option>
              <option :value="24">24</option>
              <option :value="48">48</option>
              <option :value="96">96</option>
            </select>[-->
          </div>
        </div>

        <!-- PAGINAÇÃO  
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" @click="selecionarPagina(pagina_atual - 1)">&laquo;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item"><a class="page-link" @click="selecionarPagina(pagina_atual + 1)">&raquo;</a></li>
        </ul>
        -->
        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item">
            <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
          </li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import wppController from "../../controller/wppController";
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  mixins: [wppController, sweetAlert, Swal],

  props: [],

  data() {
    return {
      container: {},
      nome: "",
      email: "",
      senha: "",
      tipo_usuario: "",
      isLoading: false,
      leiloes: "",
      paginas: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 15,
      filtro: "",
      pagina_atual: 1,
      searchBuscado: false,
    };
  },

  mounted() {
    console.log("Todos os leilões");

    const urlParams = new URLSearchParams(window.location.search);
    let page = urlParams.get("page");

    console.log("Pagina");
    console.log(page);

    if (page) {
      //this.selecionarPagina(page);
      this.pagina_atual = Number(page);
      this.inicio = this.qtd_por_pagina * (page - 1);
      this.buscarLeiloes();
    } else {
      this.buscarLeiloes();
    }

    console.log("Pagina atual");
    console.log(this.pagina_atual);
  },

  methods: {
    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarLeiloes();
    },

    limparFiltros() {
      this.filtro = "";
      this.searchBuscado = false;
      this.buscarLeiloes();
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else if (!this.validateEmail()) {
        this.showErrorMessageWithButton("Ops...", "Digite um email válido!");
      } else if (this.senha == "") {
        this.showErrorMessageWithButton("Ops...", "A senha não pode ficar em branco!");
      } else {
        this.create();
      }
    },

    selecionarPagina(pagina) {
      const urlParams = new URLSearchParams(window.location.search);

      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;

        window.history.replaceState(null, null, "?page=" + pagina);

        //urlParams.set("page", pagina);
        //  window.location.search = urlParams;

        this.buscarLeiloes();
      }
    },

    buscarLeiloes() {
      this.isLoading = true;

      let data = {
        search: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      console.log("Busca");
      console.log(data);

      axios
        .post(`/leiloes/search`, data)
        .then((response) => {
          console.log(response.data);

          if (this.filtro && this.filtro != "") {
            this.searchBuscado = true;
          } else {
            this.searchBuscado = false;
          }

          this.leiloes = response.data.leiloes;
          this.total = response.data.total;

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        return true;
      } else {
        return false;
      }
    },

    generateKey() {
      return Math.random().toString(36).slice(2);
    },
  },
};
</script>

<style scoped>
.swal-modal {
  color: green;
  background-color: rgba(63, 255, 106, 0.69);
  border: 3px solid white;
}

.swal-overlay {
  background-color: rgba(43, 165, 137, 0.45);
}
</style>
